import getConfig from 'next/config';
import { useEffect } from 'react';
import constants from '../../../config/constants';
import defaultConfig from '../../../config/url/default.config';
import { getSellerClass, getSellerLink, getTooltipText, validateSellerName } from '../helpers';

const { publicRuntimeConfig } = getConfig();

export const useSellerInfo = ({ product, appCtx, digitalData }) => {
  const { regionCode, store } = appCtx;
  const { ENVIRONMENT } = publicRuntimeConfig;
  const { currentVariant, variants, isOutOfStock } = product;

  const variant = variants.find((item) => item.id === currentVariant);
  const sellerId = variant?.offerings?.[0]?.sellerId ?? '';
  const sellerName = variant?.offerings?.[0]?.sellerName ?? '';
  const sellerNameLower = sellerName && sellerName.toLowerCase();

  const isSellerPopupEnabled = appCtx?.siteConfig?.toggles?.isSellerPopupEnabled ?? false;
  const shouldShowSellerInfo = appCtx?.siteConfig?.toggles?.isSellerInfoVisibleInPDP ?? false;
  const isSISExperienceOn = appCtx?.siteConfig?.toggles?.isSISExperienceOn ?? false;

  useEffect(() => {
    digitalData.pdp.setSoldBy(sellerNameLower);
  }, [sellerNameLower, digitalData]);

  const shouldRender = !!(sellerId && sellerName && shouldShowSellerInfo);

  const sellerClass = getSellerClass({ constants, sellerNameLower });
  const sellerRedirectionMap =
    appCtx?.siteConfig?.configurations?.sellerRedirectionMap ??
    defaultConfig?.SELLER_REDIRECTION_MAP?.[ENVIRONMENT]?.[regionCode] ??
    {};
  const validatedSellerName = validateSellerName(sellerNameLower, regionCode);

  const sellerLink = getSellerLink({
    sellerClass,
    regionCode,
    sellerName: sellerClass === 'homecenter' ? validatedSellerName.toUpperCase() : sellerName,
    env: ENVIRONMENT,
    isSISExperienceOn,
    store,
    sellerRedirectionMap,
  });

  const tooltipText = getTooltipText({
    sellerName: sellerClass || sellerNameLower,
    labels: {},
    storePlaceholderText: constants.STORE_PLACEHOLDER,
    sellerData: product.sellerInfo,
    isNational: !(product?.internationalShipping?.applicable ?? false),
  });

  return {
    sellerId,
    sellerName,
    sellerNameLower,
    validatedSellerName,
    sellerClass,
    sellerLink,
    tooltipText,
    isOutOfStock,
    isSellerPopupEnabled,
    shouldRender,
    sellerRedirectionMap,
  };
};
